import React, { useEffect, useRef, useState } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
// import Button from "@mui/material/Button";
import Button from "../Components/CommonComponent/Button";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import CloseIcon from "@mui/icons-material/Close";

import useHttp from "../Hooks/use-http";
import generatePDF from "./generatePdf";
import "./Modal.css";
import littleImage from "../Assets/Little_logo.jpg";
import { Checkbox, Chip, FormControlLabel, FormGroup, Grid } from "@mui/material";
import { toast } from "react-toastify";

let drivers = [];
let riders = [];
let reportURLs = {
  trips: "Report/ShuttleTripReport",
  shifts: "DriverShift/DriverShiftDetailsReport",
  bookingRequests: "ScheduleBooking/GetBookingRequestDetailsReport",
  scheduleTrips: "ScheduleBooking/ScheduleTripReport",
};
let driverAndRiderURLs = {
  shuttle: "ShuttleTrips/GetShuttleDriverList",
  schedule: "DriverList/GetPrivateDriverList",
  private: "DriverList/GetPrivateDriverList",
};
let date = new Date();
const Modal = (props) => {
  const [selectedRiderData, setSelectedRiderData] = useState([]);
  const [selectedDriverData, setSelectedDriverData] = useState([]);
  // const [selectedVehicleData, setSelectedVehicleData] = useState([]);

  const [isGeneratePdfClicked, setIsGeneratePdfClicked] = useState(false);
  const [isGeneratePdfClickedForShift, setIsGeneratePdfClickedForShift] =
    useState(false);
  const [isGeneratePdfClickedForFuel, setIsGeneratePdfClickedForFuel] =
    useState(false);
  const [isGeneratePdfClickedForVehicleReport, setIsGeneratePdfClickedForVehicleReport] =
    useState(false);
  const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);

  const [corporatesData, setCorporatesData] = useState([]);
  const [generatePdfError, setGeneratePdfError] = useState(false);
  const [selectedCoroparte, setSelectedCorporate] = useState({});
  const [modules, setModules] = useState([]);
  const [driverAndRiderData, setDriverAndRiderData] = useState({});
  const [selectedModule, setSelectedModule] = useState();
  const [driverListForShift, setDriverListForShift] = useState([]);
  const [vehicleListForShift, setVehicleListForShift] = useState([]);

  const [vehicles, setVehicles] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [selectedVehicles, setSelectedVehicles] = useState([]);
  const [startDateValue, setStartDateValue] = useState(
    dayjs(
      new Date(date.getFullYear() + "/" + (date.getMonth() + 1) + "/" + "01")
    )
  );
  const corpAdd = localStorage.getItem("corporateAddress");

  const [endDateValue, setEndDateValue] = useState(dayjs(new Date()));
  const [isError, setIsError] = useState(false);

  const [filterStatus, setFilterStatus] = useState({
    started: false,
    completed: true,
    pending: false,
    cancelled: false,
  });

  const authenticateUser = async (data) => {
    if (isGeneratePdfClicked) {
      try {
        if (data && data?.ReportDetails) {
          let totalKm = 0;
          let totalTrips = 0;

          for (let i = 0; i < data?.ReportDetails?.length; i++) {
            let roundOffKm = Math.ceil(data?.ReportDetails[i]?.TripDistance);
            roundOffKm = parseInt(roundOffKm, 10);
            totalKm += roundOffKm;
            totalTrips += data?.ReportDetails[i]?.Totaltrip
              ? data?.ReportDetails[i]?.Totaltrip
              : 0;
          }
          if (
            !(selectedDriverData.DriverName || selectedRiderData?.OfficialName)
          ) {
            for (let i = 0; i < data?.AdhocDriverList?.length; i++) {
              totalKm += +data?.AdhocDriverList[i]?.kilometers;
            }
          }

          await generatePDF(
            new Date(startDateValue).getDate() +
              "/" +
              (+new Date(startDateValue).getMonth() + 1) +
              "/" +
              new Date(startDateValue).getFullYear(),
            new Date(endDateValue).getDate() +
              "/" +
              (+new Date(endDateValue).getMonth() + 1) +
              "/" +
              new Date(endDateValue).getFullYear(),
            data,
            selectedRiderData?.OfficialName ?? "",
            selectedDriverData?.DriverName ?? "",
            totalTrips ? totalTrips : data?.ReportDetails?.length,
            totalKm,
            littleImage,
            document.getElementById("cpAddress").innerText,
            document.getElementById("cpAddress").clientWidth,
            props.type === "scheduleTrips",
            props.type,
            data?.AdhocDriverList
          );
        } else {
          setGeneratePdfError(true);
          setTimeout(() => setGeneratePdfError(false), 4000);
        }
      } catch (error) {
        setGeneratePdfError(true);
        toast.error(
          error?.message ||
            "Failed to generate PDF. Try a shorter date range."
        );
        setTimeout(() => setGeneratePdfError(false), 4000);
      } finally {
        setIsGeneratingPdf(false);
        setIsGeneratePdfClicked(false);
      }
    } else {
      drivers = [];
      riders = [];
      for (let i = 0; i < data?.RidersList?.length; i++) {
        riders.push({
          name: data?.RidersList[i]?.OfficialName,
          number: data?.RidersList[i]?.MobileNumber,
        });
        for (let i = 0; i < data?.PrivetDriverlist?.length; i++) {}
        drivers.push({
          name: data?.PrivetDriverlist[i]?.DriverName,
          email: data?.PrivetDriverlist[i]?.DriverEmailID,
          carNumber: data?.PrivetDriverlist[i]?.CarNumber,
        });
      }
    }
  };

  const authenticateShiftReport = async (data) => {
    if (isGeneratePdfClickedForShift) {
      try {
        if (data && data?.ReportDetails) {
          let totalKm = 0;
          let totalTrips = 0;

          for (let i = 0; i < data?.ReportDetails?.length; i++) {
            if (
              !data?.ReportDetails[i]?.CancelReason ||
              data?.ReportDetails[i]?.CancelReason === null ||
              data?.ReportDetails[i]?.CancelReason === ""
            ) {
              let roundOffKm = data?.ReportDetails[i]?.ShiftKM;
              totalKm += roundOffKm || 0;
            }

            totalTrips += data?.ReportDetails[i]?.Totaltrip
              ? data?.ReportDetails[i]?.Totaltrip
              : 0;
          }

          await generatePDF(
            new Date(startDateValue).getDate() +
              "/" +
              (+new Date(startDateValue).getMonth() + 1) +
              "/" +
              new Date(startDateValue).getFullYear(),
            new Date(endDateValue).getDate() +
              "/" +
              (+new Date(endDateValue).getMonth() + 1) +
              "/" +
              new Date(endDateValue).getFullYear(),
            data,
            "",
            "",
            totalTrips || data?.ReportDetails?.length,
            totalKm,
            littleImage,
            document.getElementById("cpAddress").innerText,
            document.getElementById("cpAddress").clientWidth,
            props.type === "scheduleTrips",
            props.type,
            data?.AdhocDriverList || []
          );
        } else {
          setGeneratePdfError(true);
          setTimeout(() => setGeneratePdfError(false), 4000);
        }
      } catch (error) {
        setGeneratePdfError(true);
        toast.error(
          error?.message ||
            "Failed to generate PDF. Try a shorter date range."
        );
        setTimeout(() => setGeneratePdfError(false), 4000);
      } finally {
        setIsGeneratingPdf(false);
        setIsGeneratePdfClickedForShift(false);
      }
    }
  };

  const authenticateFuelReport = async (data) => {
    if (isGeneratePdfClickedForFuel) {
      try {
        if (data && data?.ReportDetails) {
          const defaultAddress =
            "201-208, Venus Atlantis, Landmark, 100 Feet Anand Nagar Rd, Prahlad Nagar, Ahmedabad, Gujarat 380015";
          const cpAddress =
            document.getElementById("cpAddress")?.innerText || defaultAddress;

          const pdfData = {
            ...data,
            TotalFuel: data.TotalFuel || 0,
          };

          await generatePDF(
            new Date(startDateValue).getDate() +
              "/" +
              (+new Date(startDateValue).getMonth() + 1) +
              "/" +
              new Date(startDateValue).getFullYear(),
            new Date(endDateValue).getDate() +
              "/" +
              (+new Date(endDateValue).getMonth() + 1) +
              "/" +
              new Date(endDateValue).getFullYear(),
            pdfData,
            "",
            "",
            pdfData.TotalBillAmount,
            pdfData.AverageConsumption,
            littleImage,
            cpAddress,
            document.getElementById("cpAddress").clientWidth || 300,
            false,
            "fuel",
            []
          );
        } else {
          setGeneratePdfError(true);
          setTimeout(() => setGeneratePdfError(false), 4000);
        }
      } catch (error) {
        setGeneratePdfError(true);
        toast.error(
          error?.message ||
            "Failed to generate PDF. Try a shorter date range."
        );
        setTimeout(() => setGeneratePdfError(false), 4000);
      } finally {
        setIsGeneratingPdf(false);
        setIsGeneratePdfClickedForFuel(false);
      }
    }
  };

  const authenticateVehicleReport = async (data) => {
    if (isGeneratePdfClickedForVehicleReport) {
      try {
        if (data && data?.ReportDetails) {
          let totalKm = 0;

          for (let i = 0; i < data?.ReportDetails?.length; i++) {
            totalKm += data?.ReportDetails[i]?.DifferenceKm || 0;
          }

          const reportCount = data?.ReportDetails?.length || 0;

          await generatePDF(
            new Date(startDateValue).getDate() +
              "/" +
              (+new Date(startDateValue).getMonth() + 1) +
              "/" +
              new Date(startDateValue).getFullYear(),
            new Date(endDateValue).getDate() +
              "/" +
              (+new Date(endDateValue).getMonth() + 1) +
              "/" +
              new Date(endDateValue).getFullYear(),
            data,
            "",
            "",
            reportCount,
            totalKm,
            littleImage,
            document.getElementById("cpAddress").innerText,
            document.getElementById("cpAddress").clientWidth,
            false,
            "vehicleReport",
            []
          );
        } else {
          setGeneratePdfError(true);
          setTimeout(() => setGeneratePdfError(false), 4000);
        }
      } catch (error) {
        setGeneratePdfError(true);
        toast.error(
          error?.message ||
            "Failed to generate PDF. Try a shorter date range."
        );
        setTimeout(() => setGeneratePdfError(false), 4000);
      } finally {
        setIsGeneratingPdf(false);
        setIsGeneratePdfClickedForVehicleReport(false);
      }
    }
  };

  const getCorporateList = (data) => {
    if (localStorage.getItem("roleId") != "1") {
      const filterCorp = data?.corporates?.filter(
        (el) => el.corporateID == localStorage.getItem("corpId")
      );
      setCorporatesData(filterCorp);
    } else {
      const parentCorporate = data?.corporates?.filter(
        (el) => el.parentID === null
      );
      setCorporatesData(parentCorporate);
    }
  };

  const getDriverAndRiderData = (data) => {
    let obj = {
      driverList: data.DriverList,
      riderList: data.RidersList,
    };
    setDriverAndRiderData(obj);
  };

  const getDriverListForShift = (data) => {
    const driversArray = Array.isArray(data?.drivers)
      ? data.drivers
      : Object.values(data).filter((d) => d?.emailID && d?.fName);

    setDriverListForShift(driversArray);
    setVehicleListForShift(data?.vehicleNumbers || []);
  };

  const { isLoading, sendRequest } = useHttp();

  useEffect(() => {
    if (selectedModule)
      sendRequest(
        {
          // url: "/api/v1/" + driverAndRiderURLs[selectedModule],
          url: "/driverriderlist",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: {
            emailID: localStorage.getItem("user"),
            data: {
              corporateID:
                localStorage.getItem("roleId") == "1"
                  ? selectedCoroparte.corporateID
                  : localStorage.getItem("corpId"),
              // isRider: "1",
              // isDriver: "1",
              module: selectedModule?.toLowerCase(),
            },
            // roleID: localStorage.getItem("roleId"),
          },
        },
        getDriverAndRiderData
      );
  }, [selectedModule]);

  useEffect(() => {
    if (
      props.isShift &&
      startDateValue &&
      endDateValue &&
      selectedCoroparte?.corporateID
    ) {
      const startDate = formatToMMDDYYYYfromYYYYMMDD(startDateValue);
      const endDate = formatToMMDDYYYYfromYYYYMMDD(endDateValue);
      sendRequest(
        {
          url: "/driverListForShift",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: {
            corporateID:
              localStorage.getItem("roleId") == "1"
                ? selectedCoroparte.corporateID
                : localStorage.getItem("corpId"),
            startTime: startDate,
            endTime: endDate,
          },
        },
        getDriverListForShift
      );
    }
  }, [startDateValue, endDateValue, selectedCoroparte]);

  useEffect(() => {
    let modules = "";
    if (localStorage.getItem("roleId") === "1")
      modules = selectedCoroparte?.enabledModule?.split(",");
    else modules = localStorage.getItem("enabledModule")?.split(",");
    setModules(modules);
  }, [selectedCoroparte]);

  useEffect(() => {
    // if (localStorage.getItem("roleId") == "1")
    sendRequest(
      {
        // url: "/api/v1/Corporate/GetAllDepartmentByCorporate",
        url: "/corporates",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          emailID: localStorage.getItem("user"),
          // emailID: "deepak.pradhan@little.global",
        },
      },
      getCorporateList
    );
    // else selectedCoroparte.CorporateID = localStorage.getItem("corpId");
  }, [sendRequest]);

  useEffect(() => {
    if (props.isFuel === "1" || props.isVehicleReport === "1") {
      sendRequest(
        {
          url: "/vehicles",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: {
            emailID: localStorage.getItem("user"),
            // data: {
            //   corporateID:
            //     localStorage.getItem("roleId") == "1"
            //       ? selectedCoroparte.corporateID
            //       : localStorage.getItem("corpId"),
            // },
          },
        },
        (data) => {
          setVehicles(data?.vehicles || []);
          if (props.regNumber) {
            const vehicle = data?.vehicles?.find(
              (v) => v.regNumber === props.regNumber
            );
            if (vehicle) {
              setSelectedVehicle(vehicle);
            }
          }
        }
      );
    }
  }, [props.isFuel, props.isVehicleReport, props.regNumber, sendRequest]);

  function formatToMMDDYYYYfromYYYYMMDD(inputDate) {
    var date = new Date(inputDate);
    return (
      date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear()
    );
  }
  useEffect(() => {
    if (isGeneratePdfClicked) {
      let startDate = startDateValue
        ? formatToMMDDYYYYfromYYYYMMDD(startDateValue)
        : "";
      let endDate = endDateValue
        ? formatToMMDDYYYYfromYYYYMMDD(endDateValue)
        : "";
      sendRequest(
        {
          url: "/reports",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: {
            emailID: localStorage.getItem("user"),
            data: {
              driverEmailID: props.isShift
                ? selectedDriverData?.emailID
                : selectedDriverData?.DriverEmailID ?? "",
              riderMobileNumber: selectedRiderData?.MobileNumber ?? "",
              corporateID:
                props.type === "trips" ||
                props.type === "bookingRequests" ||
                props.type === "shifts"
                  ? selectedCoroparte.corporateID
                  : localStorage.getItem("adminDepartmentID"),
              // localStorage.getItem("corpId"),
              // isPrivateTrip: selectedModule === "private" ? "1" : "0",
              shift: props.type === "shifts" ? true : false,
              tripType: selectedModule?.toLowerCase(),
              startDate: startDate,
              endDate: endDate,
            },
          },
        },
        authenticateUser
      );
    }
  }, [isGeneratePdfClicked]);

  useEffect(() => {
    if (isGeneratePdfClickedForShift) {
      let startDate = startDateValue
        ? formatToMMDDYYYYfromYYYYMMDD(startDateValue)
        : "";
      let endDate = endDateValue
        ? formatToMMDDYYYYfromYYYYMMDD(endDateValue)
        : "";
      sendRequest(
        {
          url: "/shiftReport",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: {
            emailID: localStorage.getItem("user"),
            data: {
              emailID: props.isShift
                ? selectedDriverData?.emailID
                : selectedDriverData?.DriverEmailID ?? "",
              corporateID:
                props.type === "trips" ||
                props.type === "bookingRequests" ||
                props.type === "shifts"
                  ? selectedCoroparte.corporateID
                  : localStorage.getItem("adminDepartmentID"),
              regNumber: selectedVehicle || "",
              startDate: startDate,
              endDate: endDate,
              filterStatus: filterStatus,
            },
          },
        },
        authenticateShiftReport
      );
    }
  }, [isGeneratePdfClickedForShift]);
  useEffect(() => {
    if (isGeneratePdfClickedForFuel) {
      let startDate = startDateValue
        ? formatToMMDDYYYYfromYYYYMMDD(startDateValue)
        : "";
      let endDate = endDateValue
        ? formatToMMDDYYYYfromYYYYMMDD(endDateValue)
        : "";
      sendRequest(
        {
          url: "/fuelReport",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: {
            emailID: localStorage.getItem("user"),
            data: {
              startDate: startDate,
              endDate: endDate,
              // regNumber: props?.regNumber ?? "",
              regNumber: selectedVehicle?.regNumber || props?.regNumber || "",
            },
          },
        },
        authenticateFuelReport
      );
    }
  }, [isGeneratePdfClickedForFuel]);
  useEffect(() => {
    if (isGeneratePdfClickedForVehicleReport) {
      sendRequest(
        {
          url: "/vehicleReport",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: {
            emailID: localStorage.getItem("user"),
            data: {
              startDate: dayjs(startDateValue).format("YYYY-MM-DD"),
              endDate: dayjs(endDateValue).format("YYYY-MM-DD"),
              vehicles: selectedVehicles.map((vehicle) => ({
                regNumber: vehicle.regNumber,
              })),
              corporateID:
                localStorage.getItem("roleId") == "1"
                  ? ""
                  : localStorage.getItem("corpId") || "",
            },
          },
        },
        authenticateVehicleReport
      );
    }
  }, [isGeneratePdfClickedForVehicleReport]);

  const generatePdfClickHandler = () => {
    setIsGeneratingPdf(true);

    if (props.isVehicleReport === "1") {
      if (!selectedVehicles.length) {
        setIsGeneratingPdf(false);
        toast.error("Please select at least one vehicle");
        return;
      }
      setIsGeneratePdfClickedForVehicleReport(true);
    } else if (props.isFuel === "1") {
      setIsGeneratePdfClickedForFuel(true);
    } else if (props.isShift === "1") {
      if (!selectedCoroparte) {
        setIsError(true);
        setIsGeneratingPdf(false);
        toast.error("Please select corporate");
        return;
      }
      setIsGeneratePdfClickedForShift(true);
    } else if (!selectedModule) {
      setIsError(true);
      setIsGeneratingPdf(false);
      console.error("Selected module is not set. Please select a module.");
    } else {
      setIsGeneratePdfClicked(true);
    }
  };

  const isReportGenerating =
    isGeneratePdfClicked ||
    isGeneratePdfClickedForShift ||
    isGeneratePdfClickedForFuel ||
    isGeneratePdfClickedForVehicleReport;
  const showPdfLoader =
    (isLoading || isGeneratingPdf) && isReportGenerating;

  return (
    <div
      className="generatePdf-container"
      style={{
        zIndex: "999",
        maxWidth: window.innerWidth <= 468 ? "380px" : "",
      }}
    >
      <header>
        <span>Report</span>
        <CloseIcon
          style={{ cursor: "pointer" }}
          onClick={() => props.setIsExportButtonClicked(false)}
        />
      </header>
      <div id="cpAddress" style={{ fontSize: "0px" }}>
        {/* 201- 208, Venus Atlantis, Landmark, 100 Feet Anand Nagar Rd, Prahlad
        Nagar, Ahmedabad, Gujarat 380015
        */}

        {localStorage.getItem("roleId") == "1" && !props.isFuel == "1" ? (
          <>
            {corporatesData &&
              corporatesData?.map((corporate) => {
                if (corporate.corporateID === selectedCoroparte.corporateID) {
                  return corporate?.address;
                }
              })}
          </>
        ) : (
          corpAdd
        )}
      </div>
      <div className="generatePdf-subContainer">
        <main>
          {showPdfLoader && (
            <React.Fragment>
              <div class="wrapper">
                <div class="progressbar"></div>
                <span
                  id="progressBarText"
                  style={{
                    display: "inline-block",
                    zIndex: "999",
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  Generating Your Pdf ...
                </span>
                <br />
              </div>
            </React.Fragment>
          )}
          <Backdrop
            sx={{
              color: "rgba(34, 137, 203, 255)",
              backgroundColor: "transparent",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={isLoading && !isReportGenerating}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          {generatePdfError && (
            <div className="pdfGenerateError">
              No Records Available for Selected Fields
            </div>
          )}

          {props.isFuel !== "1" && props.isVehicleReport !== "1" && (
            <Autocomplete
              id="tags-standard"
              options={corporatesData || []}
              getOptionLabel={(cp) => cp?.name}
              // disabled={localStorage.getItem("roleId") === "1" ? false : true}
              // defaultValue={
              //   localStorage.getItem("roleId") != "1"
              //     ? { CorporateName: localStorage.getItem("cpName") }
              //     : { name: "" }
              // }
              // value={
              //   localStorage.getItem("roleId") !== "1"
              //     ? {
              //         corporateID: localStorage.getItem("corpId"),
              //         name: localStorage.getItem("cpName"),
              //       }
              //     : selectedCoroparte
              // }
              onChange={(e, newValue) =>
                newValue && setSelectedCorporate(newValue)
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="standard"
                  label="Corporate*"
                  placeholder="Search Corporate"
                />
              )}
            />
          )}

          {props.isShift !== "1" &&
            props.isFuel !== "1" &&
            props.isVehicleReport !== "1" && (
            <Autocomplete
              id="tags-standard"
              // options={modules ?? []}
              options={
                modules
                  ? modules.filter((module) => {
                      if (props?.type === "scheduleTrips") {
                        return module?.toLowerCase() === "schedule";
                      } else if (props.isShift === "1") {
                        return module?.toLowerCase() === "private";
                      } else {
                        return true; // Show all modules
                      }
                    })
                  : []
              }
              getOptionLabel={(data) => data}
              onChange={(e, newValue) => {
                setIsError(false);
                setSelectedModule(newValue?.toLowerCase());
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  error={isError}
                  helperText={isError && "This field is required"}
                  variant="standard"
                  label="Trip Type*"
                  placeholder="Search Trip Type"
                />
              )}
            />
          )}

          {props.isFuel === "1" && (
            <Autocomplete
              id="vehicle-autocomplete"
              options={vehicles} // Empty array since we don't need options
              getOptionLabel={(option) => option.regNumber || ""}
              // value={{ regNumber: props.regNumber }} // Create an object with the regNumber
              value={
                props.regNumber
                  ? { regNumber: props.regNumber }
                  : selectedVehicle
              }
              onChange={(e, newValue) => setSelectedVehicle(newValue)}
              isOptionEqualToValue={(option, value) =>
                option.regNumber === value.regNumber
              }
              disabled={!!props.regNumber}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="standard"
                  label="Vehicle Number"
                  placeholder="Search Vehicle"
                />
              )}
            />
          )}

          {props.isVehicleReport === "1" && (
            <Autocomplete
              multiple
              id="vehicle-report-autocomplete"
              options={vehicles}
              getOptionLabel={(option) => {
                const makerModel = [option.maker, option.model]
                  .filter(Boolean)
                  .join(" ");
                return makerModel
                  ? `${option.regNumber} - ${makerModel}`
                  : option.regNumber || "";
              }}
              value={selectedVehicles}
              onChange={(e, newValue) => setSelectedVehicles(newValue)}
              isOptionEqualToValue={(option, value) =>
                option.regNumber === value.regNumber
              }
              disableCloseOnSelect
              renderTags={(tagValue, getTagProps) => {
                if (!tagValue.length) return null;

                const remaining = tagValue.length - 1;
                return (
                  <>
                    <Chip
                      {...getTagProps({ index: 0 })}
                      key={tagValue[0].regNumber}
                      size="small"
                      label={tagValue[0].regNumber}
                    />
                    {remaining > 0 && (
                      <Chip
                        key="more-vehicles"
                        size="small"
                        label={`+${remaining} more`}
                        sx={{ pointerEvents: "none" }}
                      />
                    )}
                  </>
                );
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="standard"
                  label="Vehicle*"
                  placeholder={
                    selectedVehicles.length > 0 ? "" : "Search Vehicle"
                  }
                />
              )}
            />
          )}

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <div style={{ display: "flex", gap: "10px" }}>
              <DatePicker
                label="Start Date*"
                value={startDateValue}
                slotProps={{
                  textField: {
                    variant: "standard",
                    readOnly: true,
                    inputProps: { sx: { padding: "2px", fontSize: "14px" } },
                  },
                }}
                onChange={(newValue) => {
                  setStartDateValue(newValue);
                }}
              />
              <DatePicker
                label="End Date*"
                value={endDateValue}
                slotProps={{
                  textField: {
                    variant: "standard",
                    readOnly: true,
                    inputProps: { sx: { padding: "2px", fontSize: "14px" } },
                  },
                }}
                onChange={(newValue) => {
                  setEndDateValue(newValue);
                }}
              />
            </div>
          </LocalizationProvider>

          {props.isShift === "1" && props.isFuel !== "1" && (
            <>
              {selectedCoroparte?.corporateID && (
                <>
                  <Autocomplete
                    id="shift-driver-autocomplete"
                    options={driverListForShift ?? []}
                    getOptionLabel={(option) =>
                      `${option.fName ?? ""} ${option.lName ?? ""}`
                    }
                    onChange={(e, newValue) => setSelectedDriverData(newValue)}
                    isOptionEqualToValue={(option, value) =>
                      option.emailID === value.emailID
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Driver Name"
                        placeholder="Search Driver"
                      />
                    )}
                  />
                  <Autocomplete
                    id="shift-vehicle-autocomplete"
                    options={vehicleListForShift ?? []}
                    // getOptionLabel={(option) =>
                    //   `${option.fName ?? ""} ${option.lName ?? ""}`
                    // }
                    getOptionLabel={(option) => option || ""}
                    onChange={(e, newValue) => setSelectedVehicle(newValue)}
                    // isOptionEqualToValue={(option, value) =>
                    //   option.emailID === value.emailID
                    // }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Vehicle Number"
                        placeholder="Search Vehicle"
                      />
                    )}
                  />
                </>
              )}

              <FormGroup sx={{ mt: 2 }}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={filterStatus.started}
                          onChange={(e) =>
                            setFilterStatus({
                              ...filterStatus,
                              started: e.target.checked,
                            })
                          }
                        />
                      }
                      label="Started"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={filterStatus.completed}
                          onChange={(e) =>
                            setFilterStatus({
                              ...filterStatus,
                              completed: e.target.checked,
                            })
                          }
                        />
                      }
                      label="Ended"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={filterStatus.pending}
                          onChange={(e) =>
                            setFilterStatus({
                              ...filterStatus,
                              pending: e.target.checked,
                            })
                          }
                        />
                      }
                      label="Pending"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={filterStatus.cancelled}
                          onChange={(e) =>
                            setFilterStatus({
                              ...filterStatus,
                              cancelled: e.target.checked,
                            })
                          }
                        />
                      }
                      label="Cancelled"
                    />
                  </Grid>
                </Grid>
              </FormGroup>
            </>
          )}

          {props.type !== "scheduleTrips" &&
            !props.isShift &&
            props.isFuel !== "1" &&
            props.isVehicleReport !== "1" && (
              <Autocomplete
                id="tags-standard"
                options={driverAndRiderData.driverList ?? []}
                getOptionLabel={(data) =>
                  data.DriverName + " - " + data.CarNumber
                }
                onChange={(e, newValue) => setSelectedDriverData(newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    label="Driver Name"
                    placeholder="Search Driver"
                  />
                )}
              />
            )}

          {!(
            props.type === "scheduleTrips" ||
            props.isShift === "1" ||
            props.isFuel === "1" ||
            props.isVehicleReport === "1"
          ) && (
            <Autocomplete
              id="tags-standard"
              options={driverAndRiderData?.riderList ?? []}
              getOptionLabel={(data) => data?.OfficialName}
              onChange={(e, newValue) => setSelectedRiderData(newValue)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="standard"
                  label="Staff Name"
                  placeholder="Search Staff"
                />
              )}
            />
          )}

          <br />
        </main>
        <footer>
          <Button
            label={showPdfLoader ? "Generating..." : "Generate Pdf"}
            variant="contained"
            backgroundColor="green"
            onClick={generatePdfClickHandler}
            disabled={showPdfLoader}
          />
        </footer>
      </div>
    </div>
  );
};

export default Modal;

// ----------------------------------------------------------
// import React, { useEffect, useRef, useState } from "react";
// import TextField from "@mui/material/TextField";
// import Autocomplete from "@mui/material/Autocomplete";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import dayjs from "dayjs";
// import Button from "@mui/material/Button";
// import Backdrop from "@mui/material/Backdrop";
// import CircularProgress from "@mui/material/CircularProgress";
// import CloseIcon from "@mui/icons-material/Close";

// import useHttp from "../Hooks/use-http";
// import generatePDF from "./generatePdf";
// import "./Modal.css";
// import littleImage from "../Assets/Little_logo.jpg";
// import { Checkbox, FormControlLabel, FormGroup, Grid } from "@mui/material";

// let drivers = [];
// let riders = [];
// let reportURLs = {
//   trips: "Report/ShuttleTripReport",
//   shifts: "DriverShift/DriverShiftDetailsReport",
//   bookingRequests: "ScheduleBooking/GetBookingRequestDetailsReport",
//   scheduleTrips: "ScheduleBooking/ScheduleTripReport",
// };
// let driverAndRiderURLs = {
//   shuttle: "ShuttleTrips/GetShuttleDriverList",
//   schedule: "DriverList/GetPrivateDriverList",
//   private: "DriverList/GetPrivateDriverList",
// };
// let date = new Date();
// const Modal = (props) => {
//   const [selectedRiderData, setSelectedRiderData] = useState([]);
//   const [selectedDriverData, setSelectedDriverData] = useState([]);
//   const [isGeneratePdfClicked, setIsGeneratePdfClicked] = useState(false);
//   const [isGeneratePdfClickedForShift, setIsGeneratePdfClickedForShift] =
//     useState(false);
//   const [isGeneratePdfClickedForFuel, setIsGeneratePdfClickedForFuel] =
//     useState(false);

//   const [corporatesData, setCorporatesData] = useState([]);
//   const [generatePdfError, setGeneratePdfError] = useState(false);
//   const [selectedCoroparte, setSelectedCorporate] = useState({});
//   const [modules, setModules] = useState([]);
//   const [driverAndRiderData, setDriverAndRiderData] = useState({});
//   const [selectedModule, setSelectedModule] = useState();
//   const [driverListForShift, setDriverListForShift] = useState([]);
//   const [vehicles, setVehicles] = useState([]);
//   const [selectedVehicle, setSelectedVehicle] = useState(null);
//   const [startDateValue, setStartDateValue] = useState(
//     dayjs(
//       new Date(date.getFullYear() + "/" + (date.getMonth() + 1) + "/" + "01")
//     )
//   );
//   const corpAdd = localStorage.getItem("corporateAddress");

//   const [endDateValue, setEndDateValue] = useState(dayjs(new Date()));
//   const [isError, setIsError] = useState(false);

//   const [filterStatus, setFilterStatus] = useState({
//     started: false,
//     completed: true,
//     pending: false,
//     cancelled: false,
//   });

//   const authenticateUser = async (data) => {
//     if (isGeneratePdfClicked) {
//       if (data && data?.ReportDetails) {
//         let totalKm = 0;
//         let totalTrips = 0;

//         for (let i = 0; i < data?.ReportDetails?.length; i++) {
//           // TripDistanceRoundOff
//           // let roundOffKm= Math.ceil((data?.ReportDetails[i]?.TripDistance / 1000) * 10) / 10
//           let roundOffKm = Math.ceil(data?.ReportDetails[i]?.TripDistance);
//           // console.log("Round Off Km:", roundOffKm);
//           roundOffKm = parseInt(roundOffKm, 10);
//           // totalKm += data?.ReportDetails[i]?.TripDistance;
//           totalKm += roundOffKm;
//           totalTrips += data?.ReportDetails[i]?.Totaltrip
//             ? data?.ReportDetails[i]?.Totaltrip
//             : 0;
//         }
//         if (
//           !(selectedDriverData.DriverName || selectedRiderData?.OfficialName)
//         ) {
//           for (let i = 0; i < data?.AdhocDriverList?.length; i++) {
//             totalKm += +data?.AdhocDriverList[i]?.kilometers;
//           }
//         }
//         try {
//           // Convert image URL to Base64
//           // const base64Image = await convertImageToBase64(image);

//           generatePDF(
//             new Date(startDateValue).getDate() +
//               "/" +
//               (+new Date(startDateValue).getMonth() + 1) +
//               "/" +
//               new Date(startDateValue).getFullYear(),
//             new Date(endDateValue).getDate() +
//               "/" +
//               (+new Date(endDateValue).getMonth() + 1) +
//               "/" +
//               new Date(endDateValue).getFullYear(),
//             data,
//             selectedRiderData?.OfficialName ?? "", //OfficialName
//             selectedDriverData?.DriverName ?? "", //DriverName
//             totalTrips ? totalTrips : data?.ReportDetails?.length,
//             // parseInt(totalKm / 1000).toFixed(2),
//             totalKm,
//             littleImage,
//             document.getElementById("cpAddress").innerText,
//             document.getElementById("cpAddress").clientWidth,
//             props.type === "scheduleTrips",
//             props.type,
//             data?.AdhocDriverList
//           );
//         } catch (error) {
//           setGeneratePdfError(true);
//           setTimeout(() => setGeneratePdfError(false), 4000);
//         }
//       } else {
//         setGeneratePdfError(true);
//         setTimeout(() => setGeneratePdfError(false), 4000);
//       }

//       setIsGeneratePdfClicked(false);
//     } else {
//       drivers = [];
//       riders = [];
//       for (let i = 0; i < data?.RidersList?.length; i++) {
//         riders.push({
//           name: data?.RidersList[i]?.OfficialName,
//           number: data?.RidersList[i]?.MobileNumber,
//         });
//         for (let i = 0; i < data?.PrivetDriverlist?.length; i++) {}
//         drivers.push({
//           name: data?.PrivetDriverlist[i]?.DriverName,
//           email: data?.PrivetDriverlist[i]?.DriverEmailID,
//           carNumber: data?.PrivetDriverlist[i]?.CarNumber,
//         });
//       }
//     }
//   };

//   const authenticateShiftReport = async (data) => {
//     if (isGeneratePdfClickedForShift) {
//       if (data && data?.ReportDetails) {
//         let totalKm = 0;
//         let totalTrips = 0;

//         for (let i = 0; i < data?.ReportDetails?.length; i++) {
//           let roundOffKm = data?.ReportDetails[i]?.ShiftKM;
//           totalKm += roundOffKm;

//           totalTrips += data?.ReportDetails[i]?.Totaltrip
//             ? data?.ReportDetails[i]?.Totaltrip
//             : 0;
//         }

//         try {
//           generatePDF(
//             new Date(startDateValue).getDate() +
//               "/" +
//               (+new Date(startDateValue).getMonth() + 1) +
//               "/" +
//               new Date(startDateValue).getFullYear(),
//             new Date(endDateValue).getDate() +
//               "/" +
//               (+new Date(endDateValue).getMonth() + 1) +
//               "/" +
//               new Date(endDateValue).getFullYear(),
//             data,
//             "", // No RiderName in shiftReport
//             "", // No DriverName in shiftReport
//             totalTrips || data?.ReportDetails?.length,
//             totalKm,
//             littleImage,
//             document.getElementById("cpAddress").innerText,
//             document.getElementById("cpAddress").clientWidth,
//             props.type === "scheduleTrips",
//             props.type,
//             data?.AdhocDriverList || [] // Optional in shift report
//           );
//         } catch (error) {
//           setGeneratePdfError(true);
//           setTimeout(() => setGeneratePdfError(false), 4000);
//         }
//       } else {
//         setGeneratePdfError(true);
//         setTimeout(() => setGeneratePdfError(false), 4000);
//       }

//       setIsGeneratePdfClickedForShift(false);
//     }
//   };

//   const authenticateFuelReport = async (data) => {
//     if (isGeneratePdfClickedForFuel) {
//       if (data && data?.ReportDetails) {
//         try {
//           const defaultAddress =
//             "201-208, Venus Atlantis, Landmark, 100 Feet Anand Nagar Rd, Prahlad Nagar, Ahmedabad, Gujarat 380015";
//           const cpAddress =
//             document.getElementById("cpAddress")?.innerText || defaultAddress;

//           // Create a modified data object that includes TotalFuel
//           const pdfData = {
//             ...data,
//             TotalFuel: data.TotalFuel || 0, // Ensure we have a default value
//           };

//           generatePDF(
//             new Date(startDateValue).getDate() +
//               "/" +
//               (+new Date(startDateValue).getMonth() + 1) +
//               "/" +
//               new Date(startDateValue).getFullYear(),
//             new Date(endDateValue).getDate() +
//               "/" +
//               (+new Date(endDateValue).getMonth() + 1) +
//               "/" +
//               new Date(endDateValue).getFullYear(),
//             pdfData, // Pass the modified data object
//             "", // No rider for fuel report
//             "", // Vehicle number
//             pdfData.TotalBillAmount, // Total bill amount
//             pdfData.AverageConsumption, // Average consumption
//             littleImage,
//             cpAddress,
//             document.getElementById("cpAddress").clientWidth || 300,
//             false, // Not schedule booking
//             "fuel", // Report type
//             [] // No adhoc data
//           );
//         } catch (error) {
//           setGeneratePdfError(true);
//           setTimeout(() => setGeneratePdfError(false), 4000);
//         }
//       } else {
//         setGeneratePdfError(true);
//         setTimeout(() => setGeneratePdfError(false), 4000);
//       }
//       setIsGeneratePdfClickedForFuel(false);
//     }
//   };

//   const getCorporateList = (data) => {
//     if (localStorage.getItem("roleId") != "1") {
//       const filterCorp = data?.corporates?.filter(
//         (el) => el.corporateID == localStorage.getItem("corpId")
//       );
//       setCorporatesData(filterCorp);
//     } else {
//       const parentCorporate = data?.corporates?.filter(
//         (el) => el.parentID === null
//       );
//       setCorporatesData(parentCorporate);
//     }
//   };

//   const getDriverAndRiderData = (data) => {
//     let obj = {
//       driverList: data.DriverList,
//       riderList: data.RidersList,
//     };
//     setDriverAndRiderData(obj);
//   };

//   const getDriverListForShift = (data) => {
//     const driversArray = Array.isArray(data?.drivers)
//       ? data.drivers
//       : Object.values(data).filter((d) => d?.emailID && d?.fName);

//     setDriverListForShift(driversArray);
//   };

//   const getVehiclesForShift = (data) => {
//     setVehicles(data?.vehicles || []);
//   };

//   const { isLoading, sendRequest } = useHttp();

//   useEffect(() => {
//     if (selectedModule)
//       sendRequest(
//         {
//           url: "/driverriderlist",
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: {
//             emailID: localStorage.getItem("user"),
//             data: {
//               corporateID:
//                 localStorage.getItem("roleId") == "1"
//                   ? selectedCoroparte.corporateID
//                   : localStorage.getItem("corpId"),
//               module: selectedModule?.toLowerCase(),
//             },
//           },
//         },
//         getDriverAndRiderData
//       );
//   }, [selectedModule]);

//   useEffect(() => {
//     if (props.isShift === "1") {
//       // Get vehicles for shift report
//       sendRequest(
//         {
//           url: "/vehicles",
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: {
//             emailID: localStorage.getItem("user"),
//             data: {
//               corporateID:
//                 localStorage.getItem("roleId") == "1"
//                   ? selectedCoroparte.corporateID
//                   : localStorage.getItem("corpId"),
//             },
//           },
//         },
//         getVehiclesForShift
//       );
//     }
//   }, [props.isShift, selectedCoroparte]);

//   useEffect(() => {
//     let modules = "";
//     if (localStorage.getItem("roleId") === "1")
//       modules = selectedCoroparte?.enabledModule?.split(",");
//     else modules = localStorage.getItem("enabledModule")?.split(",");
//     setModules(modules);
//   }, [selectedCoroparte]);

//   useEffect(() => {
//     sendRequest(
//       {
//         url: "/corporates",
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: {
//           emailID: localStorage.getItem("user"),
//         },
//       },
//       getCorporateList
//     );
//   }, [sendRequest]);

//   useEffect(() => {
//     if (props.isFuel === "1") {
//       sendRequest(
//         {
//           url: "/vehicles",
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: {
//             emailID: localStorage.getItem("user"),
//           },
//         },
//         (data) => {
//           setVehicles(data?.vehicles || []);
//           if (props.regNumber) {
//             const vehicle = data?.vehicles?.find(
//               (v) => v.regNumber === props.regNumber
//             );
//             if (vehicle) {
//               setSelectedVehicle(vehicle);
//             }
//           }
//         }
//       );
//     }
//   }, [props.isFuel]);

//   function formatToMMDDYYYYfromYYYYMMDD(inputDate) {
//     var date = new Date(inputDate);
//     return (
//       date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear()
//     );
//   }

//   useEffect(() => {
//     if (isGeneratePdfClicked) {
//       let startDate = startDateValue
//         ? formatToMMDDYYYYfromYYYYMMDD(startDateValue)
//         : "";
//       let endDate = endDateValue
//         ? formatToMMDDYYYYfromYYYYMMDD(endDateValue)
//         : "";
//       sendRequest(
//         {
//           url: "/reports",
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: {
//             emailID: localStorage.getItem("user"),
//             data: {
//               driverEmailID: props.isShift
//                 ? selectedDriverData?.emailID
//                 : selectedDriverData?.DriverEmailID ?? "",
//               riderMobileNumber: selectedRiderData?.MobileNumber ?? "",
//               corporateID:
//                 props.type === "trips" ||
//                 props.type === "bookingRequests" ||
//                 props.type === "shifts"
//                   ? selectedCoroparte.corporateID
//                   : localStorage.getItem("adminDepartmentID"),
//               shift: props.type === "shifts" ? true : false,
//               tripType: selectedModule?.toLowerCase(),
//               startDate: startDate,
//               endDate: endDate,
//             },
//           },
//         },
//         authenticateUser
//       );
//     }
//   }, [isGeneratePdfClicked]);

//   useEffect(() => {
//     if (isGeneratePdfClickedForShift) {
//       let startDate = startDateValue
//         ? formatToMMDDYYYYfromYYYYMMDD(startDateValue)
//         : "";
//       let endDate = endDateValue
//         ? formatToMMDDYYYYfromYYYYMMDD(endDateValue)
//         : "";

//       // Check if at least one filter is selected
//       if (
//         !selectedCoroparte.corporateID &&
//         !selectedDriverData.emailID &&
//         !selectedVehicle
//       ) {
//         setGeneratePdfError(true);
//         setTimeout(() => setGeneratePdfError(false), 4000);
//         setIsGeneratePdfClickedForShift(false);
//         return;
//       }

//       sendRequest(
//         {
//           url: "/shiftReport",
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: {
//             emailID: localStorage.getItem("user"),
//             data: {
//               emailID: props.isShift
//                 ? selectedDriverData?.emailID
//                 : selectedDriverData?.DriverEmailID ?? "",
//               corporateID:
//                 props.type === "trips" ||
//                 props.type === "bookingRequests" ||
//                 props.type === "shifts"
//                   ? selectedCoroparte.corporateID
//                   : localStorage.getItem("adminDepartmentID"),
//               regNumber: selectedVehicle?.regNumber ?? "",
//               startDate: startDate,
//               endDate: endDate,
//               filterStatus: filterStatus,
//             },
//           },
//         },
//         authenticateShiftReport
//       );
//     }
//   }, [isGeneratePdfClickedForShift]);

//   useEffect(() => {
//     if (isGeneratePdfClickedForFuel) {
//       let startDate = startDateValue
//         ? formatToMMDDYYYYfromYYYYMMDD(startDateValue)
//         : "";
//       let endDate = endDateValue
//         ? formatToMMDDYYYYfromYYYYMMDD(endDateValue)
//         : "";
//       sendRequest(
//         {
//           url: "/fuelReport",
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: {
//             emailID: localStorage.getItem("user"),
//             data: {
//               startDate: startDate,
//               endDate: endDate,
//               regNumber: selectedVehicle?.regNumber || props?.regNumber || "",
//             },
//           },
//         },
//         authenticateFuelReport
//       );
//     }
//   }, [isGeneratePdfClickedForFuel]);

//   const generatePdfClickHandler = () => {
//     if (props.isFuel === "1") {
//       setIsGeneratePdfClickedForFuel(true);
//     } else if (props.isShift === "1") {
//       setIsGeneratePdfClickedForShift(true);
//     } else if (!selectedModule) {
//       setIsError(true);
//       console.error("Selected module is not set. Please select a module.");
//     } else {
//       setIsGeneratePdfClicked(true);
//     }
//   };

//   return (
//     <div
//       className="generatePdf-container"
//       style={{
//         zIndex: "999",
//         maxWidth: window.innerWidth <= 468 ? "380px" : "",
//       }}
//     >
//       <header>
//         <span>Report</span>
//         <CloseIcon
//           style={{ cursor: "pointer" }}
//           onClick={() => props.setIsExportButtonClicked(false)}
//         />
//       </header>
//       <div id="cpAddress" style={{ fontSize: "0px" }}>
//         {localStorage.getItem("roleId") == "1" && !props.isFuel == "1" ? (
//           <>
//             {corporatesData &&
//               corporatesData?.map((corporate) => {
//                 if (corporate.corporateID === selectedCoroparte.corporateID) {
//                   return corporate?.address;
//                 }
//               })}
//           </>
//         ) : (
//           corpAdd
//         )}
//       </div>
//       <div className="generatePdf-subContainer">
//         <main>
//           {isLoading && isGeneratePdfClicked && (
//             <React.Fragment>
//               <div class="wrapper">
//                 <div class="progressbar"></div>
//                 <span
//                   id="progressBarText"
//                   style={{
//                     display: "inline-block",
//                     zIndex: "999",
//                     width: "100%",
//                     textAlign: "center",
//                   }}
//                 >
//                   Generating Your Pdf ...
//                 </span>
//                 <br />
//               </div>
//             </React.Fragment>
//           )}
//           <Backdrop
//             sx={{
//               color: "rgba(34, 137, 203, 255)",
//               backgroundColor: "transparent",
//               zIndex: (theme) => theme.zIndex.drawer + 1,
//             }}
//             open={isLoading && !isGeneratePdfClicked}
//           >
//             <CircularProgress color="inherit" />
//           </Backdrop>
//           {generatePdfError && (
//             <div className="pdfGenerateError">
//               {props.isShift === "1"
//                 ? "Please select at least one filter (Corporate, Driver, or Vehicle)"
//                 : "No Records Available for Selected Fields"}
//             </div>
//           )}

//           {props.isFuel !== "1" && (
//             <Autocomplete
//               id="tags-standard"
//               options={corporatesData || []}
//               getOptionLabel={(cp) => cp?.name}
//               onChange={(e, newValue) =>
//                 newValue && setSelectedCorporate(newValue)
//               }
//               renderInput={(params) => (
//                 <TextField
//                   {...params}
//                   variant="standard"
//                   label="Corporate"
//                   placeholder="Search Corporate"
//                 />
//               )}
//             />
//           )}

//           {props.isShift !== "1" && props.isFuel !== "1" && (
//             <Autocomplete
//               id="tags-standard"
//               options={
//                 modules
//                   ? modules.filter((module) => {
//                       if (props?.type === "scheduleTrips") {
//                         return module?.toLowerCase() === "schedule";
//                       } else if (props.isShift === "1") {
//                         return module?.toLowerCase() === "private";
//                       } else {
//                         return true;
//                       }
//                     })
//                   : []
//               }
//               getOptionLabel={(data) => data}
//               onChange={(e, newValue) => {
//                 setIsError(false);
//                 setSelectedModule(newValue?.toLowerCase());
//               }}
//               renderInput={(params) => (
//                 <TextField
//                   {...params}
//                   error={isError}
//                   helperText={isError && "This field is required"}
//                   variant="standard"
//                   label="Trip Type*"
//                   placeholder="Search Trip Type"
//                 />
//               )}
//             />
//           )}

//           {props.isFuel === "1" && (
//             <Autocomplete
//               id="vehicle-autocomplete"
//               options={vehicles}
//               getOptionLabel={(option) => option.regNumber || ""}
//               value={
//                 props.regNumber
//                   ? { regNumber: props.regNumber }
//                   : selectedVehicle
//               }
//               onChange={(e, newValue) => setSelectedVehicle(newValue)}
//               isOptionEqualToValue={(option, value) =>
//                 option.regNumber === value.regNumber
//               }
//               disabled={!!props.regNumber}
//               renderInput={(params) => (
//                 <TextField
//                   {...params}
//                   variant="standard"
//                   label="Vehicle Number"
//                   placeholder="Search Vehicle"
//                 />
//               )}
//             />
//           )}

//           <LocalizationProvider dateAdapter={AdapterDayjs}>
//             <div style={{ display: "flex", gap: "10px" }}>
//               <DatePicker
//                 label="Start Date*"
//                 value={startDateValue}
//                 slotProps={{
//                   textField: {
//                     variant: "standard",
//                     readOnly: true,
//                     inputProps: { sx: { padding: "2px", fontSize: "14px" } },
//                   },
//                 }}
//                 onChange={(newValue) => {
//                   setStartDateValue(newValue);
//                 }}
//               />
//               <DatePicker
//                 label="End Date*"
//                 value={endDateValue}
//                 slotProps={{
//                   textField: {
//                     variant: "standard",
//                     readOnly: true,
//                     inputProps: { sx: { padding: "2px", fontSize: "14px" } },
//                   },
//                 }}
//                 onChange={(newValue) => {
//                   setEndDateValue(newValue);
//                 }}
//               />
//             </div>
//           </LocalizationProvider>

//           {/* for the shifts */}
//           {props.isShift === "1" && props.isFuel !== "1" && (
//             <>
//               <Autocomplete
//                 id="shift-driver-autocomplete"
//                 options={driverListForShift ?? []}
//                 getOptionLabel={(option) =>
//                   `${option.fName ?? ""} ${option.lName ?? ""}`
//                 }
//                 onChange={(e, newValue) => setSelectedDriverData(newValue)}
//                 isOptionEqualToValue={(option, value) =>
//                   option.emailID === value.emailID
//                 }
//                 renderInput={(params) => (
//                   <TextField
//                     {...params}
//                     variant="standard"
//                     label="Driver Name"
//                     placeholder="Search Driver"
//                   />
//                 )}
//               />

//               <Autocomplete
//                 id="shift-vehicle-autocomplete"
//                 options={vehicles}
//                 getOptionLabel={(option) => option.regNumber || ""}
//                 onChange={(e, newValue) => setSelectedVehicle(newValue)}
//                 isOptionEqualToValue={(option, value) =>
//                   option.regNumber === value.regNumber
//                 }
//                 renderInput={(params) => (
//                   <TextField
//                     {...params}
//                     variant="standard"
//                     label="Vehicle Number"
//                     placeholder="Search Vehicle"
//                   />
//                 )}
//               />

//               <FormGroup sx={{ mt: 2 }}>
//                 <Grid container spacing={2}>
//                   <Grid item xs={6}>
//                     <FormControlLabel
//                       control={
//                         <Checkbox
//                           checked={filterStatus.started}
//                           onChange={(e) =>
//                             setFilterStatus({
//                               ...filterStatus,
//                               started: e.target.checked,
//                             })
//                           }
//                         />
//                       }
//                       label="Started"
//                     />
//                   </Grid>
//                   <Grid item xs={6}>
//                     <FormControlLabel
//                       control={
//                         <Checkbox
//                           checked={filterStatus.completed}
//                           onChange={(e) =>
//                             setFilterStatus({
//                               ...filterStatus,
//                               completed: e.target.checked,
//                             })
//                           }
//                         />
//                       }
//                       label="Ended"
//                     />
//                   </Grid>
//                   <Grid item xs={6}>
//                     <FormControlLabel
//                       control={
//                         <Checkbox
//                           checked={filterStatus.pending}
//                           onChange={(e) =>
//                             setFilterStatus({
//                               ...filterStatus,
//                               pending: e.target.checked,
//                             })
//                           }
//                         />
//                       }
//                       label="Pending"
//                     />
//                   </Grid>
//                   <Grid item xs={6}>
//                     <FormControlLabel
//                       control={
//                         <Checkbox
//                           checked={filterStatus.cancelled}
//                           onChange={(e) =>
//                             setFilterStatus({
//                               ...filterStatus,
//                               cancelled: e.target.checked,
//                             })
//                           }
//                         />
//                       }
//                       label="Cancelled"
//                     />
//                   </Grid>
//                 </Grid>
//               </FormGroup>
//             </>
//           )}

//           {props.type !== "scheduleTrips" &&
//             !props.isShift &&
//             props.isFuel !== "1" && (
//               <Autocomplete
//                 id="tags-standard"
//                 options={driverAndRiderData.driverList ?? []}
//                 getOptionLabel={(data) =>
//                   data.DriverName + " - " + data.CarNumber
//                 }
//                 onChange={(e, newValue) => setSelectedDriverData(newValue)}
//                 renderInput={(params) => (
//                   <TextField
//                     {...params}
//                     variant="standard"
//                     label="Driver Name"
//                     placeholder="Search Driver"
//                   />
//                 )}
//               />
//             )}

//           {!(
//             props.type === "scheduleTrips" ||
//             props.isShift === "1" ||
//             props.isFuel === "1"
//           ) && (
//             <Autocomplete
//               id="tags-standard"
//               options={driverAndRiderData?.riderList ?? []}
//               getOptionLabel={(data) => data?.OfficialName}
//               onChange={(e, newValue) => setSelectedRiderData(newValue)}
//               renderInput={(params) => (
//                 <TextField
//                   {...params}
//                   variant="standard"
//                   label="Staff Name"
//                   placeholder="Search Staff"
//                 />
//               )}
//             />
//           )}

//           <br />
//         </main>
//         <footer>
//           <Button
//             variant="contained"
//             color="success"
//             onClick={generatePdfClickHandler}
//           >
//             Generate Pdf
//           </Button>
//         </footer>
//       </div>
//     </div>
//   );
// };

// export default Modal;
